import { VendorBills } from "components/VendorBills/VendorBills";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { usePageTitle } from "hooks/usePageTitle";
import { useState } from "react";
import { RowSelectionState } from "react-table-8.10.7";

type BillsProps = {
  canRequestAndAddBill?: boolean;
};

export const Bills = ({ canRequestAndAddBill }: BillsProps) => {
  usePageTitle("Bills");
  const entityId = useCurrentEntityId();

  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  return (
    <VendorBills
      entityId={entityId}
      canRequestAndAddBill={canRequestAndAddBill}
      rowSelection={rowSelection}
      setRowSelection={setRowSelection}
    />
  );
};
